import { LoadingButton } from "@mui/lab";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import { Box, Alert } from "@mui/material";
import { Modal } from "../Modal";
import { OnActionCb } from "./types";
import BackButton from "../BackButton";
import { ButtonWrapper } from "./index.style";

export interface DeleteModalProps {
  handleCloseModal: () => void;
  onDelete: OnActionCb;
  openModal: boolean;
  error: string;
  isDeleting: boolean;
}

export const DeleteModal = (props: DeleteModalProps) => {
  const { openModal, onDelete, handleCloseModal, error, isDeleting } = props;

  return (
    <Modal
      title={
        <Box sx={{ display: "flex", alignItems: "center" }}>Delete record</Box>
      }
      open={openModal}
      handleClose={handleCloseModal}
      actions={
        <ButtonWrapper>
          {!error && (
            <LoadingButton
              autoFocus
              onClick={onDelete}
              variant="contained"
              color="error"
              loading={isDeleting}
            >
              Delete
            </LoadingButton>
          )}
          <BackButton onClick={handleCloseModal} disabled={isDeleting} />
        </ButtonWrapper>
      }
    >
      {error ? (
        <Alert severity="error">{error}</Alert>
      ) : (
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <ReportProblemIcon
            color="warning"
            sx={{ mr: "5px" }}
            fontSize="large"
          />
          Are you sure you want to DELETE the selected record ?
        </Box>
      )}
    </Modal>
  );
};
